/* DelaFuente — No preselected RING SIZE (Blue Nile model).
 * Style/metal/carat/birthstone keep the theme's visual defaults — only ring size must be
 * an explicit choice (a wrong default size is the one that silently ruins an order).
 * The size dropdown gets a "Select your size" placeholder that masks the theme's default
 * VISUALLY (the internal option[selected] attribute is untouched, so variant resolution,
 * price and morphs keep working) and add-to-cart is gated until a size is picked.
 *
 * UX pattern:
 *  - The add-to-cart button label becomes the pending step ("Select your size", or the
 *    custom gates: birthstone ring-size property, letter-ring initial) until resolved.
 *  - Nothing is shown preemptively; if the shopper still taps the button, we scroll to
 *    the missing control, bold its label, and show a small inline message right there.
 *
 * Coexists with the letter, birthstone and diamond pickers via their gate attributes
 * and window.DLF_NPS. Vanilla, no deps.
 */
(function () {
  var cfgEl = document.getElementById('dlf-nps-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { CFG = {}; }
  var ES = String(CFG.lang || '').slice(0, 2).toLowerCase() === 'es';
  var L = ES ? {
    selectSize: 'Elige tu talla', selectOpt: 'Elige una opción',
    btn: { metal: 'Elige tu metal', carat: 'Elige el quilataje', size: 'Elige tu talla', birthstone: 'Elige tu piedra', initial: 'Elige tu inicial', generic: 'Elige tus opciones' },
    msg: { metal: 'Elige tu metal para continuar', carat: 'Elige el quilataje para continuar', size: 'Elige tu talla para continuar', birthstone: 'Elige tu piedra para continuar', initial: 'Elige tu inicial para continuar', generic: 'Elige una opción para continuar' }
  } : {
    selectSize: 'Select your size', selectOpt: 'Select an option',
    btn: { metal: 'Select your metal', carat: 'Select your carat', size: 'Select your size', birthstone: 'Select your birthstone', initial: 'Choose your initial', generic: 'Select your options' },
    msg: { metal: 'Select your metal to continue', carat: 'Select your carat to continue', size: 'Select your size to continue', birthstone: 'Select your birthstone to continue', initial: 'Choose your initial to continue', generic: 'Select an option to continue' }
  };

  var touched = {};
  var nudged = {};   // group keys whose inline message should stay until resolved

  /* ---------- option groups on the MAIN product picker only ---------- */
  function mainPicker() {
    var vps = document.querySelectorAll('variant-picker');
    for (var i = 0; i < vps.length; i++) {
      if (!vps[i].closest('product-card, quick-add-dialog, featured-product-information')) return vps[i];
    }
    return null;
  }
  function labelOf(el) {
    var lg = el.querySelector('legend, label');
    if (!lg) return '';
    var n = lg.childNodes[0];
    return ((n && n.textContent) || lg.textContent || '').trim();
  }
  function keyOf(lb) { return lb.toLowerCase(); }
  function kindOf(k) {
    if (k.indexOf('carat') > -1 || k.indexOf('quilat') > -1) return 'carat';
    if (k.indexOf('ring size') === 0 || k.indexOf('talla') === 0 || k.indexOf('size') === 0) return 'size';
    if (k.indexOf('birthstone') > -1 || k.indexOf('piedra') > -1) return 'birthstone';
    if (k.indexOf('color') > -1 || k.indexOf('metal') > -1) return 'metal';
    return 'generic';
  }
  function groups() {
    var vp = mainPicker();
    if (!vp) return [];
    var out = [];
    vp.querySelectorAll('fieldset.variant-option').forEach(function (fs) {
      if (fs.querySelectorAll('input[type="radio"]').length < 2) return;
      var lb = labelOf(fs);
      out.push({ el: fs, type: 'radio', label: lb, key: keyOf(lb) });
    });
    vp.querySelectorAll('.variant-option--dropdowns').forEach(function (w) {
      var sel = w.querySelector('select');
      if (!sel) return;
      var lb = labelOf(w);
      out.push({ el: w, sel: sel, type: 'select', label: lb, key: keyOf(lb) });
    });
    // Blue Nile model: only ring size requires an explicit pick.
    return out.filter(function (g) { return kindOf(g.key) === 'size'; });
  }
  function satisfied(g) {
    return !!touched[g.key];
  }
  function missing() { return groups().filter(function (g) { return !satisfied(g); }); }
  // Where to point the shopper for a group (the birthstone fieldset is hidden — its
  // visible UI is the .dlf-bs gem dots).
  function targetOf(g) {
    if (kindOf(g.key) === 'birthstone') {
      var bs = document.querySelector('.dlf-bs');
      if (bs) return bs;
    }
    return g.el;
  }
  // All pending steps in page order: native groups, then the custom gates that other
  // dlf scripts hold via attributes on the buy button.
  function pendingSteps() {
    var steps = missing().map(function (g) { return { kind: kindOf(g.key), el: targetOf(g), key: g.key, group: g }; });
    var btn = mainBtn();
    if (btn) {
      if (btn.hasAttribute('data-rs-required')) {
        var rs = document.querySelector('.dlf-rs');
        if (rs) steps.push({ kind: 'size', el: rs, key: '__rs' });
      }
      if (btn.hasAttribute('data-letter-required')) {
        var lp = document.querySelector('.dlf-lp');
        if (lp) steps.push({ kind: 'initial', el: lp, key: '__letter' });
      }
    }
    return steps;
  }

  /* ---------- visual masking ---------- */
  function maskSelect(g, on) {
    var sel = g.sel;
    var ph = sel.querySelector('option[data-dlf-nps-ph]');
    if (on) {
      if (!ph) {
        ph = document.createElement('option');
        ph.setAttribute('data-dlf-nps-ph', '');
        ph.value = '';
        ph.disabled = true;
        ph.textContent = kindOf(g.key) === 'size' ? L.selectSize : L.selectOpt;
        sel.insertBefore(ph, sel.firstChild);
      }
      // Property-only selection: the real option keeps its selected= ATTRIBUTE, which is
      // what the theme's variant logic reads, so nothing breaks underneath. Use the
      // .selected/.selectedIndex properties (NOT sel.value=''): iOS Safari ignores
      // value-assignment onto disabled options.
      if (!ph.selected) { ph.selected = true; if (sel.selectedIndex !== 0) sel.selectedIndex = 0; }
      g.el.classList.add('dlf-nps-mask');
    } else {
      if (ph) {
        if (ph.selected) {
          var real = sel.querySelector('option[selected]');
          if (real) real.selected = true;
        }
        ph.remove();
      }
      g.el.classList.remove('dlf-nps-mask');
    }
  }
  function apply() {
    // Even with no native size dropdown (the birthstone template sizes via its own .dlf-rs
    // property select), we still run the gate/label pass so the button reflects the custom
    // gates' attributes.
    var gs = groups();
    var miss = [];
    gs.forEach(function (g) {
      var on = !satisfied(g);
      if (on) miss.push(g);
      if (g.type === 'radio') g.el.classList.toggle('dlf-nps-mask', on);
      else maskSelect(g, on);
    });
    refreshGate(miss);
    refreshStepsUI();
    return !!(gs.length || mainBtn());
  }

  /* ---------- add-to-cart gate (same pattern as the letter/birthstone gates) ---------- */
  function buyForm() { return document.querySelector('form[action*="/cart/add"]'); }
  function mainBtn() { var f = buyForm(); return f && f.querySelector('button[type="submit"]'); }
  function stickyBtn() { return document.querySelector('.sticky-add-to-cart__button'); }
  function refreshGate(miss) {
    var btn = mainBtn();
    if (!btn) return;
    var acc = document.querySelector('.accelerated-checkout-block');
    // Always observe the button: the custom gates (letter / birthstone size) set their
    // attributes on their own schedule and the step label must follow.
    if (!btn.__dlfNpsObs) {
      var obs = new MutationObserver(function () {
        if (btn.hasAttribute('data-nps-required') && !btn.disabled) btn.disabled = true;
        refreshStepsUI();
      });
      obs.observe(btn, { attributes: true, attributeFilter: ['disabled', 'data-letter-required', 'data-rs-required'] });
      btn.__dlfNpsObs = obs;
    }
    if (miss.length) {
      btn.setAttribute('data-nps-required', '');
      btn.disabled = true;
      if (acc) acc.classList.add('dlf-nps-hide');
    } else {
      btn.removeAttribute('data-nps-required');
      if (acc) acc.classList.remove('dlf-nps-hide');
      // Only re-enable if no other gate (initial / ring size / stock) is holding the button.
      if (!btn.hasAttribute('data-letter-required') && !btn.hasAttribute('data-rs-required') &&
          !btn.hasAttribute('data-size-required') && !btn.hasAttribute('data-oos') &&
          !btn.hasAttribute('data-dp-blocked')) {
        btn.disabled = false;
      }
    }
  }

  /* ---------- progressive button label + inline messages ---------- */
  function textNodeOf(btn) {
    var content = btn.querySelector('.add-to-cart-text__content');
    if (!content) return btn.querySelector('.add-to-cart-text') || null;
    // The label lives down the FIRST span chain (main: span>span, sticky: span).
    // Don't touch sibling spans (the sticky bar keeps a count span in there too).
    var node = content;
    while (node.firstElementChild && node.firstElementChild.tagName === 'SPAN') node = node.firstElementChild;
    return node;
  }
  function setBtnLabel(btn, label) {
    if (!btn) return;
    var node = textNodeOf(btn);
    if (!node) return;
    if (label == null) {
      // Restore only if the current text is still ours (don't clobber "Sold out" etc.).
      if (node.dataset.dlfNpsLabel != null && node.textContent === node.dataset.dlfNpsLabel && node.dataset.dlfNpsOrig != null) {
        node.textContent = node.dataset.dlfNpsOrig;
      }
      delete node.dataset.dlfNpsLabel;
      delete node.dataset.dlfNpsOrig;
    } else if (node.textContent !== label) {
      // If the theme rewrote the text since our last pass, treat that as the new original.
      node.dataset.dlfNpsOrig = (node.dataset.dlfNpsLabel != null && node.textContent === node.dataset.dlfNpsLabel && node.dataset.dlfNpsOrig != null)
        ? node.dataset.dlfNpsOrig
        : node.textContent;
      node.textContent = label;
      node.dataset.dlfNpsLabel = label;
    }
  }
  function msgFor(key) { return document.querySelector('.dlf-nps-inline[data-dlf-nps-msg="' + key + '"]'); }
  function ensureMsg(step) {
    var el = msgFor(step.key);
    if (!el) {
      el = document.createElement('p');
      el.className = 'dlf-nps-inline';
      el.setAttribute('data-dlf-nps-msg', step.key);
      el.setAttribute('role', 'alert');
    }
    el.textContent = L.msg[step.kind] || L.msg.generic;
    // (Re)insert right after the group's UI — morphs may wipe it, refreshStepsUI re-adds.
    if (el.previousElementSibling !== step.el && step.el.parentNode) {
      step.el.parentNode.insertBefore(el, step.el.nextSibling);
    }
    return el;
  }
  function refreshStepsUI() {
    var steps = pendingSteps();
    var label = steps.length ? (L.btn[steps[0].kind] || L.btn.generic) : null;
    setBtnLabel(mainBtn(), label);
    setBtnLabel(stickyBtn(), label);
    // Keep the inline message + bolded label only for still-pending nudged steps;
    // re-add if a morph ate them.
    document.querySelectorAll('.dlf-nps-attn').forEach(function (el) { el.classList.remove('dlf-nps-attn'); });
    var pendingByKey = {};
    steps.forEach(function (s) { pendingByKey[s.key] = s; });
    Object.keys(nudged).forEach(function (key) {
      var step = pendingByKey[key];
      if (step) {
        ensureMsg(step);
        step.el.classList.add('dlf-nps-attn');
      } else {
        delete nudged[key];
        var el = msgFor(key);
        if (el) el.remove();
      }
    });
  }
  function nudge() {
    apply();
    var steps = pendingSteps();
    if (!steps.length) return;
    nudged[steps[0].key] = true;
    refreshStepsUI();
    steps[0].el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ---------- wiring ---------- */
  // A real interaction with an option group marks it as chosen (also covers the birthstone
  // dots and "Help me later", which fire native change events).
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var vp = t.closest('variant-picker');
    if (vp && vp === mainPicker()) {
      var host = t.closest('fieldset.variant-option, .variant-option--dropdowns');
      if (host && !(t.tagName === 'SELECT' && !t.value)) {
        touched[keyOf(labelOf(host))] = true;
      }
    }
    // Any change (incl. the birthstone size property select) can move the next step along.
    setTimeout(apply, 0);
  }, true);

  // The theme morphs the variant picker on every variant change — re-apply the masks after.
  document.addEventListener('variant:update', function () { setTimeout(apply, 0); });

  // Clicking an option ALSO counts as choosing it — clicking the value that happens to be
  // checked underneath fires no change event, but it's still an explicit pick.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var lab = t.closest('.variant-option__button-label');
    if (lab && lab.closest('variant-picker') === mainPicker()) {
      var host = lab.closest('fieldset.variant-option');
      if (host) { touched[keyOf(labelOf(host))] = true; setTimeout(apply, 0); }
    }
    // Same for the birthstone dots (they drive the hidden native fieldset).
    if (t.closest('.dlf-bs__item')) {
      groups().forEach(function (g) { if (kindOf(g.key) === 'birthstone') touched[g.key] = true; });
    }
    // Custom picker interactions (diamond choose/remove, letters, gem dots, help-me-later)
    // change what counts as pending.
    if (t.closest('[data-dp], [data-action], .dlf-hml-btn, .dlf-lp__btn, .dlf-bs__item, .dlf-rs__help')) {
      setTimeout(apply, 60);
    }
  });

  // Nudge on attempted add while steps are pending: the disabled main button lets the click
  // fall through (pointer-events:none) to its wrapper; the sticky bar button is intercepted.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!pendingSteps().length) return;
    var sticky = t.closest('.sticky-add-to-cart__button, sticky-add-to-cart, .sticky-add-to-cart');
    var buyArea = t.closest('add-to-cart-component, buy-buttons-component');
    if (!sticky && !buyArea) return;
    if (sticky) { e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); }
    nudge();
  }, true);

  // Public hook: the diamond picker consults this before its hand-pick bundle add-to-cart.
  window.DLF_NPS = { ready: function () { return missing().length === 0; }, nudge: nudge };

  // First pass runs synchronously (the script loads after the picker markup), so the masks
  // and the step label are in place before the first paint; dlf-boot in the <head> covers
  // the gap on slow loads and comes off here.
  var tries = 0;
  function firstApply() {
    var done = apply() || ++tries > 25;
    if (done) document.documentElement.classList.remove('dlf-boot');
    return done;
  }
  if (!firstApply()) {
    var iv = setInterval(function () {
      if (firstApply()) clearInterval(iv);
    }, 250);
  }
})();
